import { Box, Divider, Heading, Table, Tbody, Td, Tr, Text } from '@chakra-ui/react'
import React from 'react'

const BillDetails = ({ bills, total, paid }) => {
    console.log(total)
    return (
        <Box bgColor={'#FFFFFF'} shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} my={5} p={3}>
            <Heading size={'md'} mb={2}>Bill Details</Heading>
            <Divider size={1} my={2} borderBottomColor={'black'} />
            <Table>
                <Tbody>
                    {bills.map((bill, i) => (
                        <Tr key={i}>
                            <Td _first={{paddingLeft: '0px'}} fontSize={'medium'} fontWeight={"semibold"}>{Object.keys(bill)[0]}</Td>
                            <Td fontSize={'medium'} fontWeight={'semibold'}>{bill[Object.keys(bill)[0]][0]}</Td>
                            <Td fontSize={'medium'} textAlign={'right'} fontWeight={'semibold'}>{bill[Object.keys(bill)[0]][1]}</Td>
                        </Tr>
                    ))}
                    <Tr>
                        <Td _first={{paddingLeft: '0px'}} fontSize={'medium'} fontWeight={'bold'}>Total</Td>
                        <Td></Td>
                        <Td textAlign={'right'}><Text as="span" fontWeight={'bold'}>&#8377;{total}</Text></Td>
                    </Tr>
                    {/* <Tr py={2}>
                        <Td _first={{paddingLeft: '0px'}} fontSize={'medium'} fontWeight={'bold'}>Paid by Customer</Td>
                        <Td></Td>
                        <Td textAlign={'right'}>&#8377; <Text as="span" fontWeight={'extrabold'}>{paid}</Text></Td>
                    </Tr> */}
                </Tbody>
            </Table>
        </Box>
    )
}

export default BillDetails
